import { useNavigate } from 'react-router-dom';
import { LogOut,  UserCircle}  from 'lucide-react';
import { getRoleFromToken } from '../api';

const roleLabels = {
  admin: 'Administrador',
  financeiro: 'Financeiro',
  rh: 'Recursos Humanos',
  diretor: 'Diretoria',
  administracao: 'Administração',
  usuario: 'Usuário Comum',
  viagens: 'Viagem'
};

const modules = [
  {
    path: '/margem-bruta',
    title: 'Margem Bruta',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    tag: 'Resultado',
    description:
      'Visão consolidada do faturamento por projeto cruzado com o custo de mão de obra, calculando automaticamente a margem bruta de cada operação.',
    highlights: ['Faturamento', 'Custo MOB', 'Margem %'],
    allowedRoles: ['admin' ,'financeiro', 'diretor', 'administracao']
  },
  {
    path: '/orcamento-dash',
    title: 'Orçamento',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 11h.01M12 11h.01M15 11h.01M4 19h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    tag: 'Planejamento',
    description:
      'Acompanhamento do orçamento previsto versus realizado por departamento, com gastos agrupados por categoria para facilitar a análise de desvios.',
    highlights: ['Por Departamento', 'Por Categoria', 'Previsto vs Real'],
    allowedRoles: ['admin' ,"RH","TI","ADMFIN","NEGOCIOS","EXECUTIVA","QUALIDADE","VIAGENS","COMERCIAL","RH","JURIDICO","OPERACAO", ]

  },
  {
    path: '/custos-por-projeto',
    title: 'Detalhamento de Custos',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
      </svg>
    ),
    tag: 'Lançamentos',
    description:
      'Listagem completa de todos os lançamentos de custo por projeto, permitindo drill-down analítico em cada movimentação financeira registrada.',
    highlights: ['Todos Lançamentos', 'Filtros Avançados', 'Por Projeto'],
    allowedRoles: ['admin' , 'rh' , 'financeiro', 'diretor' , 'administracao']
  },
  {
    path: '/simulacao-folha',
    title: 'Simulador de Folha',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 11h.01M12 11h.01M15 11h.01M4 19h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    tag: 'Simulação',
    description:
      'Ferramenta de simulação financeira para modelar cenários de reajuste salarial, novas contratações e desligamentos, projetando o impacto na folha de pagamento.',
    highlights: ['Reajuste Salarial', 'Contratações', 'Desligamentos'],
    allowedRoles: ['admin' , 'rh' , 'financeiro', 'diretor']

  },
  {
    path: '/salarios-por-projeto',
    title: 'Detalhamento Salarial',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    tag: 'RH & Custos',
    description:
      'Visibilidade completa da remuneração dos colaboradores segmentada por departamento e projeto, auxiliando na análise de custo de pessoal.',
    highlights: ['Por Colaborador', 'Por Departamento', 'Custo Total'],
    allowedRoles: ['admin' , 'rh' , 'financeiro', 'diretor']
  },
  {
    path: '/painel-executivo',
    title: 'Painel Executivo',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    tag: 'Contabilidade',
    description:
      'Visibilidade completa da remuneração dos colaboradores segmentada por departamento e projeto, auxiliando na análise de custo de pessoal.',
    highlights: ['Por Empresa', 'Saldos Iniciais e Finais' , 'Geração de Caixa'],
    allowedRoles: ['admin' , 'financeiro', 'diretor']

  },

];

const tagColors = {
  'Resultado':    'bg-emerald-100 text-emerald-700',
  'Planejamento': 'bg-blue-100 text-blue-700',
  'Lançamentos':  'bg-amber-100 text-amber-700',
  'Simulação':    'bg-violet-100 text-violet-700',
  'RH & Custos':  'bg-rose-100 text-rose-700',
  'Contabilidade':  'bg-emerald-100 text-emerald-700',
};

export default function Welcome() {
  const navigate = useNavigate();
  const userRole = getRoleFromToken();

  const availableModules = modules.filter(mod => 
    !mod.allowedRoles || mod.allowedRoles.includes(userRole)
  );

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* ── Header idêntico ao Login ── */}
      <header className="bg-gradient-to-r from-purple-900 to-pink-800 text-white px-6 py-4 flex justify-between items-center shadow-md">
        <div className="flex items-center space-x-2">
          <span className="text-2xl font-bold tracking-tight">YOUX</span>
          <span className="text-xl font-light">GROUP</span>
        </div>
          {/* PERFIL DISCRETO NO HEADER */}
          <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-white/10 rounded-full border border-white/20">
            <UserCircle className="w-4 h-4 text-pink-300" />
            <span className="text-xs font-medium text-purple-100 uppercase tracking-wider">
              Perfil: {roleLabels[userRole] || userRole}
            </span>
          </div>
        <button
          onClick={() => {
            localStorage.removeItem('token');
            navigate('/');
          }}

            className="flex items-center gap-2 px-4 py-2 hover:bg-red-500/20 rounded-lg text-sm font-bold text-white-400"
        >
          <LogOut className="w-4 h-4" />
          Sair 
        </button>
      </header>

      {/* ── Hero de boas-vindas ── */}
      <div className="bg-gradient-to-r from-purple-900 to-pink-800 text-white px-6 pb-10 pt-6">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl font-bold leading-tight">
            Boas-vindas ao Painel Financeiro 
          </h1>
          <p className="mt-2 text-purple-200 text-sm max-w-xl">
            Selecione um módulo abaixo para acessar as análises e ferramentas disponíveis para a sua equipe.
          </p>
        </div>
      </div>

      {/* ── Grid de cards ── */}
      <main className="flex-1 px-6 py-10 -mt-4">
        <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {availableModules.map((mod) => (
            <button
              key={mod.path}
              onClick={() => navigate(mod.path)}
              className="group text-left bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 flex flex-col gap-4 focus:outline-none focus:ring-2 focus:ring-pink-500"
            >
              {/* Ícone + tag */}
              <div className="flex items-start justify-between">
                <div className="bg-gradient-to-br from-purple-900 to-pink-800 text-white p-3 rounded-xl shadow-md group-hover:scale-105 transition-transform duration-200">
                  {mod.icon}
                </div>
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${tagColors[mod.tag]}`}>
                  {mod.tag}
                </span>
              </div>

              {/* Título + descrição */}
              <div>
                <h2 className="text-base font-semibold text-gray-800 mb-1 group-hover:text-pink-700 transition-colors">
                  {mod.title}
                </h2>
                <p className="text-sm text-gray-500 leading-relaxed">
                  {mod.description}
                </p>
              </div>

              {/* Highlights */}
              <div className="flex flex-wrap gap-1.5 mt-auto pt-2 border-t border-gray-100">
                {mod.highlights.map((h) => (
                  <span
                    key={h}
                    className="text-xs text-gray-400 bg-gray-50 border border-gray-200 px-2 py-0.5 rounded-md"
                  >
                    {h}
                  </span>
                ))}
              </div>

              {/* CTA inline */}
              <span className="text-xs font-medium text-pink-700 group-hover:underline">
                Acessar módulo →
              </span>
            </button>
          ))}
        </div>
      </main>

      <footer className="text-center text-xs text-gray-400 py-6">
        © {new Date().getFullYear()} Youx Group · by financeiro
      </footer>
    </div>
  );
}